import { Stack } from '@fluentui/react';
import { useFetch } from '@moko/ui';
import {
  getPricingParameters,
  type IPricingParameter,
} from '../../services/pricingParameterService';
import PricingParameterLoadError from './PricingParameterLoadError';
import PricingParameterMaintenance from './PricingParameterMaintenance';
import type { PricingParameterCatalog } from './usePricingParameterCatalog';

export interface GlobalPricingParameterPanelProps {
  isAdmin: boolean;
  catalog: PricingParameterCatalog;
  pricingItemId: number;
}

const GlobalPricingParameterPanel = ({
  isAdmin,
  catalog,
  pricingItemId,
}: GlobalPricingParameterPanelProps) => {
  const recordsFetch = useFetch<IPricingParameter[]>({
    queryKey: ['globalPricingParameters', pricingItemId],
    queryFn: (abortController) =>
      getPricingParameters(abortController, 'global', pricingItemId),
  });

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <PricingParameterLoadError error={recordsFetch.error} />
      <PricingParameterMaintenance
        scope="global"
        canMutate={
          isAdmin &&
          catalog.ready &&
          !recordsFetch.loading &&
          !recordsFetch.error
        }
        definitions={catalog.definitions}
        pricingItemId={pricingItemId}
        records={recordsFetch.error ? [] : recordsFetch.data ?? []}
        loading={recordsFetch.loading}
        emptyTitle="No global values"
        emptySubtitle="No global parameter values exist for this pricing item."
        onChanged={recordsFetch.refetch}
      />
    </Stack>
  );
};

export default GlobalPricingParameterPanel;
